/* eslint-disable import/no-cycle */
/* eslint-disable  */
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import storage from "redux-persist/lib/storage";
import ENVIRONMENT from "../config/environment";
import { SLICE } from "../modules/common/constants/slice";
import { summarySlice } from "../modules/dashboard/summary-tab/slice";
import { globalSlice } from "../modules/common/components/slice";

/**
 * White listed slices which need to be persisted with encryption
 */
const persistConfig = {
  version: ENVIRONMENT.PERSIST_VERSION,
  key: ENVIRONMENT.PERSIST_KEY,
  storage,
  stateReconciler: hardSet,
  whitelist: [SLICE.SUMMARY, SLICE.GLOBAL],
};
/**
 * Combine all the persist and non persist reducers
 */
const reducers = combineReducers({
  [SLICE.SUMMARY]: summarySlice.reducer,
  [SLICE.GLOBAL]: globalSlice.reducer,
});
/**
 * Define what are the slice which needs to be persist
 */
const persistedReducer = persistReducer(persistConfig, reducers);
/**
 * Register all the slices into the main store with encryption
 */
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: { ignoredActions: ["persist/PERSIST"] },
    }),
  ],
});
// persistStore(store);
//
export default store;
